





















import { Vue, Component, Prop } from 'vue-property-decorator';
import { Person } from '@/models/person';
import StudentSelect from './studentSelect.vue';
import { SchoolTypes } from '@/enums/schoolTypes';
import { Student } from '@/modules/student';
import { Subject } from '@/models/subject';

export interface SubmitArgs {
  selectedStudents: Person[];
  cancelClose: boolean;
}

@Component({
  components: {
    'student-select': StudentSelect
  }
})
export default class StudentSelectDialog extends Vue {
  private SchoolTypes = SchoolTypes;

  @Prop({ required: true }) private title: string;
  @Prop({ default: '選択' }) private submitLabel: string;
  @Prop({ default: 'キャンセル' }) private cancelLabel: string;
  @Prop({ default: 0 }) private schoolTypeFilter: number;
  @Prop() private selectedStudents: string[];
  @Prop() private visible: boolean;
  @Prop() private appendToBody: boolean;
  @Prop() private enableSubject?: Subject;

  private visibleDialog = false;
  private selectedStudentsModel = new Array<string>();

  private created() {
    this.visibleDialog = this.visible;
  }

  private mounted() {
    this.loadData();
  }

  private loadData() {
    if (!!this.selectedStudents) {
      this.selectedStudentsModel = this.selectedStudents;
    }
  }

  private submit() {
    const checkedStudents = (this.$refs.tree as any).getCheckedStudents();
    const args: SubmitArgs = { selectedStudents: checkedStudents, cancelClose: false };
    this.$emit('submit', args);
    if (!args.cancelClose) {
      this.$emit('update:selectedStudents', checkedStudents);
      this.visibleDialog = false;
    }
  }

  private cancel() {
    this.visibleDialog = false;
    this.$emit('cancel');
  }

  private close() {
    this.$emit('update:visible', this.visibleDialog);
  }
}
